import { Alert, AlertTitle, Button, Grid } from '@mui/material';
import { t } from 'i18next';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';

type MemberResignMemberNotAuthorizedModalProps = {
  modalOpen: boolean;
  onClose: () => void;
};

export const MemberResignMemberNotAuthorizedModal = (props: MemberResignMemberNotAuthorizedModalProps) => {
  const { modalOpen, onClose } = props;

  return (
    <GenericDialog
      open={modalOpen}
      onClose={onClose}
      onSave={onClose}
      maxWidth='xs'
      showDialogActions
      padding={0}
      dialogTitle={t('member:exitMember.exitOfMembership')}
      dialogContent={
        <Grid container>
          <Grid item xs={12}>
            <Alert severity='error'>
              <AlertTitle>{t('member:exitMember.householdMainMemberCannotExit')}</AlertTitle>
              {t('member:exitMember.householdMainMemberExitNeedsAdjust')}
            </Alert>
          </Grid>
        </Grid>
      }
      dialogActions={
        <Button autoFocus variant='contained' color='primary' disableElevation onClick={onClose}>
          {t('common:button.ok')}
        </Button>
      }
    />
  );
};
